import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineHeart, AiFillHeart } from 'react-icons/ai';
import { useAuth } from '../context/AuthContext';
import { useProducts } from '../context/ProductsContext';
import './Recommended.css';

const Recommended = () => {
    const navigate = useNavigate();
    const { addToWishlist, removeFromWishlist, isInWishlist } = useAuth();
    const { getRecommendedProducts, loading } = useProducts();

    // Get products from the live catalog
    const productsFromJson = getRecommendedProducts(8);
    
    // Transform to display format
    const products = productsFromJson.map(product => {
        // Use originalPrice as base and discountedPrice from JSON
        const originalPrice = typeof product.originalPrice === 'string' 
            ? parseInt(product.originalPrice) 
            : product.originalPrice;
        
        const discountedPrice = product.discountedPrice && product.discountedPrice !== ''
            ? (typeof product.discountedPrice === 'string' ? parseInt(product.discountedPrice) : product.discountedPrice)
            : originalPrice;
        
        const discount = product.discount && product.discount !== '' 
            ? (typeof product.discount === 'string' ? parseInt(product.discount) : product.discount)
            : 0;
        
        return {
            // Keep original data for navigation
            ...product,
            id: product.productId,
            image: product.images[0],
            title: product.productTitle,
            name: product.productTitle,
            originalPrice: originalPrice,
            discountedPrice: discountedPrice,
            discount: discount,
            inStock: product.inStock,
            category: product.category
        };
    });

    const handleWishlistToggle = (product) => {
        if (isInWishlist(product.id)) {
            removeFromWishlist(product.id);
        } else {
            const wishlistItem = {
                id: product.id,
                title: product.title,
                name: product.name,
                originalPrice: product.originalPrice,
                discountedPrice: product.discountedPrice,
                discount: product.discount,
                image: product.image,
                inStock: product.inStock,
                category: product.category
            };
            addToWishlist(wishlistItem);
        }
    };

    return (
        <div className="recommended-section">
            <div className="recommended-header">
                <div className="header-left">
                    <div className="red-circle"></div>
                    <h2>Recommended</h2>
                </div>
                <button className="see-more">See more</button>
            </div>

            {loading ? (
                <p>Loading products...</p>
            ) : (
            <div className="products-grid">
                {products.map((product) => (
                    <div 
                        key={product.id} 
                        className="product-card"
                        onClick={() => navigate(`/product/${product.id}`, { state: { product } })}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="product-image-container">
                            <img src={product.image} alt={product.title} className="product-image" />
                            {product.discount && <div className="discount-badge">{product.discount}%</div>}
                            <button 
                                className="wishlist-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleWishlistToggle(product);
                                }}
                            >
                                {isInWishlist(product.id) ? (
                                    <AiFillHeart size={20} color="#e63946" />
                                ) : (
                                    <AiOutlineHeart size={20} color="#666" />
                                )}
                            </button>
                        </div>
                        <div className="product-info">
                            <h3 className="product-title">{product.title}</h3>
                            <div className="product-price">
                                {product.discount > 0 ? (
                                    <>
                                        <span className="original-price">₹{product.originalPrice}</span>
                                        <span className="current-price">₹{product.discountedPrice}</span>
                                    </>
                                ) : (
                                    <span className="current-price">₹{product.originalPrice}</span>
                                )}
                            </div>
                            <div className={`product-stock ${product.inStock ? 'in-stock' : 'out-of-stock'}`}>
                                {product.inStock ? '✓ In Stock' : '✗ Out of Stock'}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            )}
        </div>
    );
};

export default Recommended;
